import React, { FC, useMemo } from 'react';
import { AnalyticsUpdatedProjectsProps } from './AnalyticsUpdatedProjectsProps';
import { BarChartPro } from '@mui/x-charts-pro/BarChartPro';
import AnalyticsLoader from '../AnalyticsLoader';
import { groupByDate } from '../AnalyticsCreatedProjects/utils';

const AnalyticsUpdatedProjects: FC<AnalyticsUpdatedProjectsProps> = ({
  data,
  grouping,
  loading,
}) => {
  const chartData: any[] = useMemo(() => {
    return groupByDate(data, grouping);
  }, [data, grouping]);

  const valueWithPercentageFormatter = () => {
    return (value, { dataIndex }) => {
      const total = chartData[dataIndex]?.total;
      const percentage = total
        ? ` (${((value / total) * 100).toFixed(0)}%)`
        : '';
      return `${value}${percentage}`;
    };
  };

  return (
    <AnalyticsLoader loading={loading}>
      <BarChartPro
        dataset={chartData}
        xAxis={[
          {
            scaleType: 'band',
            dataKey: 'date',
            tickLabelStyle: { angle: -45 },
          },
        ]}
        series={[
          {
            dataKey: 'BULK',
            label: 'Bulk',
            stack: 'total',
            valueFormatter: valueWithPercentageFormatter(),
          },
          {
            dataKey: 'MODAL',
            label: 'Modal',
            stack: 'total',
            valueFormatter: valueWithPercentageFormatter(),
          },
        ]}
        slotProps={{
          legend: {
            direction: 'row',
            position: { vertical: 'top', horizontal: 'middle' },
          },
        }}
        slots={{
          noDataOverlay: () => null,
        }}
      />
    </AnalyticsLoader>
  );
};

export default AnalyticsUpdatedProjects;
